import { TableRow, TableCell, Paragraph, convertMillimetersToTwip } from "docx";
export default function generateLvTableRow(positionNumber, descriptionParagraph, amount, unit) {
  return new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph("00" + positionNumber)],
        margins: {
          top: convertMillimetersToTwip(1),
          bottom: convertMillimetersToTwip(1),
          left: convertMillimetersToTwip(1),
          right: convertMillimetersToTwip(1),
        },
      }),
      new TableCell({
        children: [descriptionParagraph],
      }),
      new TableCell({
        children: [new Paragraph(amount)],
      }),
      new TableCell({
        children: [new Paragraph(unit)],
      }),
      new TableCell({
        children: [new Paragraph(".......")],
      }),
      new TableCell({
        children: [new Paragraph(".......")],
      }),
    ],
  });
}
